import { render, staticRenderFns } from "./Invoice.vue?vue&type=template&id=5532a24d&scoped=true&"
import script from "./Invoice.vue?vue&type=script&lang=js&"
export * from "./Invoice.vue?vue&type=script&lang=js&"
import style0 from "./Invoice.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Invoice.vue?vue&type=style&index=1&id=5532a24d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5532a24d",
  null
  
)

export default component.exports